import { styled } from "styled-components";

export const Arch = styled.div`
  color: ${({ theme }) => theme.colors.default[50]};
  display: block;
  overflow: hidden;
  position: absolute;
  bottom: 0;
  margin-bottom: -1px;
  left: 50%;
  transform: translateX(-50%);
  z-index: 0;

  @media (min-width: 2400px) {
    display: none;
  }
`;

export const NotFoundWrapper = styled.div`
  width: 100vw;
  display: flex;
  justify-content: center;
  position: relative;
  height: fit-content;
  overflow: hidden;
`;

export const NotFoundContainer = styled.div`
  padding: 156px 24px 200px 24px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
  gap: 24px;
  position: relative;
  max-width: ${({ theme }) => theme.content.maxWidth}px;

  ${({ theme }) => theme.breakpoints.sm.query} {
    text-align: left;
    justify-content: flex-start;
    align-items: flex-start;
  }
`;
